import { render, staticRenderFns } from "./communityIntegralDetail.vue?vue&type=template&id=45ca4fe2&scoped=true"
import script from "./communityIntegralDetail.vue?vue&type=script&lang=js"
export * from "./communityIntegralDetail.vue?vue&type=script&lang=js"
import style0 from "./communityIntegralDetail.vue?vue&type=style&index=0&id=45ca4fe2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ca4fe2",
  null
  
)

export default component.exports